import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmExclusionReason } from '../interfaces/IKnmExclusionReason';

export async function fetchKnmExclusionReasons(): Promise<IKnmExclusionReason[]> {
  return apiGet<IKnmExclusionReason[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-exclusion-reasons`,
  );
}
